// Canonical form-control styles for the Parvis design system. Light surface,
// hairline border, primary (parish-themed) focus ring. See the design-system skill.
export const inputClass = [
  'bg-surface border border-line rounded-md px-4 py-3 w-full',
  'focus:outline-none focus:border-primary focus:shadow-[0_0_0_3px_rgb(from_var(--color-primary)_r_g_b/0.12)]',
  'text-on-surface placeholder:text-on-surface-light/70 transition-all duration-200',
].join(' ');

export const inputErrorClass = [
  'bg-surface border border-error rounded-md px-4 py-3 w-full',
  'focus:outline-none focus:border-error focus:shadow-[0_0_0_3px_rgba(186,26,26,0.12)]',
  'text-on-surface placeholder:text-on-surface-light/70 transition-all duration-200',
].join(' ');

export type SectionLabelColor = 'primary' | 'secondary' | 'tertiary';

export function sectionLabel(color: SectionLabelColor = 'primary'): string {
  const colorClass = {
    primary: 'text-primary',
    secondary: 'text-secondary',
    tertiary: 'text-tertiary',
  }[color];
  return `text-xs font-bold tracking-widest uppercase ${colorClass} mb-4 pb-2 border-b border-line block`;
}

// Canonical card base — light surface, hairline border, 12px radius.
export const cardBase = 'rounded-lg border border-line bg-surface';

// Trigger button shared by the popover controls (DatePicker / TimePicker) so
// they match the canonical input exactly. Keeps every form control identical.
export function pickerTriggerClass(opts: {
  open?: boolean;
  hasError?: boolean;
  disabled?: boolean;
}): string {
  const state = opts.hasError
    ? 'border-error focus:outline-none focus:border-error focus:shadow-[0_0_0_3px_rgba(186,26,26,0.12)]'
    : opts.open
      ? 'border-primary shadow-[0_0_0_3px_rgb(from_var(--color-primary)_r_g_b/0.12)]'
      : 'border-line hover:border-line-strong focus:outline-none focus:border-primary focus:shadow-[0_0_0_3px_rgb(from_var(--color-primary)_r_g_b/0.12)]';
  return [
    'w-full flex items-center justify-between gap-2 rounded-md px-4 py-3',
    'bg-surface border text-on-surface text-left transition-all duration-200',
    state,
    opts.disabled ? 'opacity-50 cursor-not-allowed' : '',
  ]
    .filter(Boolean)
    .join(' ');
}
